// import { useState } from "react";
// import { Clock, Users, Star, Code, Zap } from "lucide-react";
// import { Link } from "react-router-dom";
// import { allCoursesOffer } from "../CourseOffer";

// const allCourses = Object.entries(allCoursesOffer).map(([slug, course]) => ({
//     id: slug,
//     title: course.title,
//     description: course.description,
//     category: course.category,
//     duration: course.duration,
//     students: course.students,
//     rating: course.rating,
//     image: course.image,
//     slug: slug,
// }));

// const categories = [
//     "All",
//     "Computer Application",
//     "Programming",
//     "Hardware",
//     "Visual&Animation",
//     "Tally",
//     "AutoCAD"
// ];

// const courseDescriptions = {
//     "Computer Application":
//         "Core computer applications including operating systems, office productivity suites, databases, and essential digital skills for workplace efficiency",

//     "Programming":
//         "Programming languages and software development fundamentals for building robust applications",

//     "Hardware":
//         "Computer hardware, networking, and system maintenance skills for building and managing IT infrastructure",

//     "Visual&Animation":
//         "Creative design, video, audio, animation, and visual effects skills for media and entertainment industries",

//     "Tally":
//         "Accounting and GST-ready bookkeeping with Tally, including invoicing, inventory, reporting, and compliance for businesses",

//     "AutoCAD":
//         "2D/3D CAD drafting and design workflows using AutoCAD for architecture, engineering, and manufacturing projects",
// };

// export function AllCoursesOffer() {
//     const [selectedCategory, setSelectedCategory] = useState("All");

//     const filteredCourses =
//         selectedCategory === "All"
//             ? allCourses
//             : allCourses.filter((course) => course.category === selectedCategory);

//     return (
//         <div className="container mx-auto px-4 mt-12 overflow-hidden">
//             <div
//                 className="text-center mb-8"
//                 data-aos="fade-down"
//                 data-aos-duration="1200"
//             >
//                 <h1 className="text-4xl font-bold text-gray-900 mb-4 mt-20">
//                     Courses Offered
//                 </h1>
//                 <p
//                     className="text-lg text-gray-600"
//                     data-aos="fade-left"
//                     data-aos-duration="1200"
//                 >
//                     Explore our comprehensive range of courses designed to advance your
//                     career
//                 </p>
//             </div>

//             <div
//                 className="flex flex-wrap justify-center gap-2 mb-8"
//                 data-aos="fade-up"
//                 data-aos-duration="1200"
//             >
//                 {categories.map((category) => (
//                     <button
//                         key={category}
//                         onClick={() => setSelectedCategory(category)}
//                         className={`px-4 py-2 rounded border text-sm font-medium mb-2 ${selectedCategory === category
//                             ? "bg-blue-600 text-white"
//                             : "border-gray-300 text-gray-700 hover:bg-gray-100"
//                             }`}
//                     >
//                         {category}
//                     </button>
//                 ))}
//             </div>

//             {selectedCategory !== "All" && (
//                 <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
//                     <div className="flex items-center mb-2">
//                         <Code className="h-6 w-6 text-blue-600 mr-2" />
//                         <h2 className="text-xl font-semibold text-gray-900">
//                             {selectedCategory} Courses
//                         </h2>
//                     </div>
//                     <p className="text-gray-700">
//                         {courseDescriptions[selectedCategory]}
//                     </p>
//                 </div>
//             )}

//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
//                 {filteredCourses.map((course, index) => {
//                     const aosAnimations = ["fade-left", "fade-up-left", "zoom-in-left"];
//                     const aosType = aosAnimations[index % aosAnimations.length];

//                     return (
//                         <div
//                             key={course.id}
//                             data-aos={aosType}
//                             data-aos-duration="1000"
//                             className="bg-white border rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition duration-300 relative"
//                         >
//                             {course.category === "Full Stack" && (
//                                 <span className="absolute top-2 right-2 bg-green-500 text-white text-xs font-medium px-2 py-1 rounded flex items-center z-10">
//                                     <Zap className="h-3 w-3 mr-1" /> Popular
//                                 </span>
//                             )}
//                             <div className="overflow-hidden">
//                                 <img
//                                     src={course.image || "/placeholder.svg"}
//                                     alt={course.title}
//                                     className="w-full h-48 object-cover rounded-t hover:scale-105 transition-transform duration-300 shadow"
//                                 />
//                             </div>
//                             <div className="p-4">
//                                 <div className="text-xs text-blue-600 font-medium mb-1">
//                                     {course.category}
//                                 </div>
//                                 <h3 className="text-lg font-bold mb-1 text-black">
//                                     {course.title}
//                                 </h3>
//                                 <p className="text-sm text-gray-600 mb-3 line-clamp-2">
//                                     {course.description}
//                                 </p>
//                                 <div className="flex items-center justify-between text-sm text-gray-500 mb-2">
//                                     <div className="flex items-center">
//                                         <Clock className="h-4 w-4 mr-1" />
//                                         {course.duration}
//                                     </div>
//                                     <div className="flex items-center">
//                                         <Users className="h-4 w-4 mr-1" />
//                                         {course.students}
//                                     </div>
//                                 </div>
//                                 <div className="flex items-center">
//                                     <Star className="h-4 w-4 text-yellow-400 mr-1" />
//                                     <span className="text-sm font-medium text-black">
//                                         {course.rating}
//                                     </span>
//                                 </div>
//                             </div>
//                             <div className="p-4 pt-0">
//                                 <Link
//                                     to={`/offered/${course.slug}`}
//                                     className="block text-center w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition"
//                                 >
//                                     Learn More
//                                 </Link>
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>

//             <section className="bg-gray-50 rounded-lg p-8 mb-12">
//                 <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
//                     Why Choose CSG Education?
//                 </h2>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//                     {[
//                         {
//                             icon: <Users className="h-8 w-8 text-blue-600" />,
//                             bg: "bg-blue-100",
//                             title: "Experienced Trainers",
//                             desc: "Learn from industry experts with years of practical experience",
//                         },
//                         {
//                             icon: <Star className="h-8 w-8 text-green-600" />,
//                             bg: "bg-green-100",
//                             title: "Job-Oriented Training",
//                             desc: "Curriculum designed to meet current industry demands and trends",
//                         },
//                         {
//                             icon: <Clock className="h-8 w-8 text-purple-600" />,
//                             bg: "bg-purple-100",
//                             title: "Certification",
//                             desc: "Get industry-recognized certificates upon successful completion",
//                         },
//                         {
//                             icon: <Star className="h-8 w-8 text-orange-600" />,
//                             bg: "bg-orange-100",
//                             title: "Real-Time Projects",
//                             desc: "Work on live projects to gain hands-on practical experience",
//                         },
//                     ].map((item, index) => (
//                         <div
//                             key={index}
//                             className="text-center border rounded-lg p-6 bg-white shadow-sm hover:shadow-md transition duration-300 hover:-translate-y-1"
//                         >
//                             <div
//                                 className={`${item.bg} rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 transition-transform duration-300 hover:scale-110`}
//                             >
//                                 {item.icon}
//                             </div>
//                             <h3 className="text-lg font-semibold mb-2 text-black">
//                                 {item.title}
//                             </h3>
//                             <p className="text-gray-600">{item.desc}</p>
//                         </div>
//                     ))}
//                 </div>
//             </section>
//         </div>
//     );
// }

import { useState } from "react";
import { Clock, Users, Star, Code, Zap } from "lucide-react";
import { Link } from "react-router-dom";

// Hardcoded categories and courses
const categories = [
  "All",
  "Software courses",
  "Hardware Courses",
  "Multimedia courses",
  "Ai course",
];

const courseDescriptions = {
  "Software courses":
    "Programming, Full Stack, Tally, CAD, Java, PHP, Web, and more.",
  "Hardware Courses":
    "Networking, Server, Redhat Linux, Microsoft Server, A+N+, CCNA/CCNP.",
  "Multimedia courses":
    "Video editing, 2D/3D animation, Audio editing, Visual Effects, Graphic Design.",
  "Ai course": "Data Science, Data Analytics, Machine Learning, AI/ML courses.",
};

const allCourses = [
  // Software courses
  {
    id: "python",
    title: "Python",
    category: "Software courses",
    description: "Learn Python programming from basics to advanced.",
    duration: "30h",
    students: 1200,
    rating: 4.5,
    image: "../assets/python.jpg",
    slug: "/software/python",
  },
  {
    id: "java-full-stack",
    title: "Java Full Stack",
    category: "Software courses",
    description: "Complete Java Full Stack development course with projects.",
    duration: "40h",
    students: 950,
    rating: 4.7,
    image: "../assets/ca016a07ec7f33937cc2194023a5214c.jpg",
    slug: "/software/fullstack/java",
  },
  {
    id: "python-full-stack",
    title: "Python Full Stack",
    category: "Software courses",
    description: "Full Stack web development using Python (Django + React).",
    duration: "40h",
    students: 870,
    rating: 4.6,
    image: "./assets/d5316057f65a7e52459f1740ee5a8b4b.jpg",
    slug: "/software/fullstack/python",
  },
  {
    id: "php-full-stack",
    title: "PHP Full Stack",
    category: "Software courses",
    description: "PHP Full Stack course with Laravel and frontend integration.",
    duration: "35h",
    students: 750,
    rating: 4.4,
    image: "./assets/R-C.png",
    slug: "/software/fullstack/php",
  },
  {
    id: "dotnet-full-stack",
    title: ".NET Full Stack",
    category: "Software courses",
    description: ".NET Full Stack development including C# and ASP.NET.",
    duration: "40h",
    students: 650,
    rating: 4.3,
    image: "../assets/OIP.jpeg",
    slug: "/software/fullstack/dotnet",
  },
  {
    id: "c-cpp",
    title: "C, C++ Programming",
    category: "Software courses",
    description: "Learn C and C++ programming from beginner to expert.",
    duration: "25h",
    students: 900,
    rating: 4.2,
    image: "../assets/image.jpeg",
    slug: "/software/ccpp",
  },
  {
    id: "tally",
    title: "Tally",
    category: "Software courses",
    description: "Accounting and GST-ready bookkeeping with Tally ERP.",
    duration: "20h",
    students: 1100,
    rating: 4.5,
    image:
      "./assets/features-of-tally2-p00ew337nx5knciartvv2soas2avlppczl45p286ms.webp",
    slug: "/software/others/tally",
  },
  {
    id: "cad",
    title: "AutoCAD",
    category: "Software courses",
    description: "2D/3D CAD drafting and design using AutoCAD.",
    duration: "30h",
    students: 700,
    rating: 4.4,
    image: "./assets/4a90606fd98d793eda4312d6917617a7.jpg",
    slug: "/software/others/cad",
  },

  // Hardware Courses
  {
    id: "a+n+",
    title: "A+N+",
    category: "Hardware Courses",
    description: "A+N+ hardware course for IT infrastructure skills.",
    duration: "30h",
    students: 600,
    rating: 4.3,
    image: "./assets/Hardware.jpg",
    slug: "/hardware/a+n+",
  },
  {
    id: "ccna",
    title: "CCNA",
    category: "Hardware Courses",
    description: "CCNA networking course for Cisco certifications.",
    duration: "35h",
    students: 550,
    rating: 4.5,
    image: "./assets/fb30fe775c30d4d56defbf5db56a3b3d.jpg",
    slug: "/hardware/ccna",
  },
  {
    id: "ccnp",
    title: "CCNP",
    category: "Hardware Courses",
    description: "CCNP advanced networking course.",
    duration: "40h",
    students: 400,
    rating: 4.2,
    image: "./assets/7bba1f78d59942853b9981bc9604f30c.jpg",
    slug: "/hardware/ccnp",
  },
  {
    id: "redhat",
    title: "RedHat Linux",
    category: "Hardware Courses",
    description: "RedHat Linux system administration.",
    duration: "30h",
    students: 500,
    rating: 4.4,
    image: "https://linuxiac.b-cdn.net/wp-content/uploads/2022/05/rhel9.jpg",
    slug: "/hardware/redhat",
  },
  {
    id: "microsoft",
    title: "Microsoft Server",
    category: "Hardware Courses",
    description: "Microsoft Server administration course.",
    duration: "35h",
    students: 450,
    rating: 4.3,
    image: "./assets/385942da8eed411be076a36c9b167d05.jpg",
    slug: "/hardware/microsoft",
  },

  // Multimedia courses
  {
    id: "2d-video",
    title: "2D Video Editing",
    category: "Multimedia courses",
    description: "2D Video editing basics.",
    duration: "25h",
    students: 800,
    rating: 4.5,
    image: "./assets/9bddfa4f20f6b7abc39908e33194c56e.jpg",
    slug: "/multimedia/twoD",
  },
  {
    id: "3d-video",
    title: "3D Video Editing",
    category: "Multimedia courses",
    description: "3D Video editing course.",
    duration: "30h",
    students: 700,
    rating: 4.4,
    image: "./assets/f9d8a09dbf65a9e94713b38fa16e6f67.jpg",
    slug: "/multimedia/threeD",
  },
  {
    id: "audio",
    title: "Audio Editing",
    category: "Multimedia courses",
    description: "Audio editing and production.",
    duration: "20h",
    students: 650,
    rating: 4.3,
    image: "./assets/480cda32088d4e5a1c0e4f53a2bb0fbc.jpg",
    slug: "/multimedia/audio",
  },
  {
    id: "vfx",
    title: "Visual Effects",
    category: "Multimedia courses",
    description: "Visual Effects creation.",
    duration: "30h",
    students: 600,
    rating: 4.5,
    image: "./assets/e46fa3ea4bd1869702bc3d18cc1b6d01.jpg",
    slug: "/multimedia/VFX",
  },
  {
    id: "3d-animation",
    title: "3D Animation",
    category: "Multimedia courses",
    description: "3D animation fundamentals.",
    duration: "35h",
    students: 550,
    rating: 4.4,
    image: "./assets/6b5611a98cd8787de790ec9dfacc54bc.jpg",
    slug: "/multimedia/3d-animation",
  },

  // AI courses
  {
    id: "datascience",
    title: "Data Science",
    category: "Ai course",
    description: "Data Science course for analytics.",
    duration: "40h",
    students: 800,
    rating: 4.6,
    image: "./assets/14cbc10e848a3e5e794c11b57bf1ba3c.jpg",
    slug: "/software/aicourses/datascience",
  },
  {
    id: "dataanalytics",
    title: "Data Analytics",
    category: "Ai course",
    description: "Data Analytics course for business insights.",
    duration: "35h",
    students: 750,
    rating: 4.5,
    image: "./assets/6c461bc61ae1012c6fd6fec0a5eef284.jpg",
    slug: "/software/aicourses/dataanalytics",
  },
  {
    id: "machinelearning",
    title: "Machine Learning",
    category: "Ai course",
    description: "Machine Learning algorithms and projects.",
    duration: "40h",
    students: 700,
    rating: 4.4,
    image: "./assets/Machine-Learning-5.jpeg",
    slug: "/software/aicourses/machinelearning",
  },
  {
    id: "aiml",
    title: "AI & ML",
    category: "Ai course",
    description: "AI & ML complete course.",
    duration: "45h",
    students: 650,
    rating: 4.5,
    image: "./assets/a445d88a9a7aeafb686ece191c60bd82.jpg",
    slug: "/software/aicourses/aiml",
  },
];

export function AllCoursesOffer() {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredCourses =
    selectedCategory === "All"
      ? allCourses
      : allCourses.filter(
          (course) =>
            course.category.toLowerCase() === selectedCategory.toLowerCase()
        );

  return (
    <div className="container mx-auto px-4 mt-12 overflow-hidden">
      <div
        className="text-center mb-8"
        data-aos="fade-down"
        data-aos-duration="1200"
      >
        <h1 className="text-4xl font-bold text-gray-900 mb-4 mt-20">
          Courses Offered
        </h1>
        <p
          className="text-lg text-gray-600"
          data-aos="fade-left"
          data-aos-duration="1200"
        >
          Explore our comprehensive range of courses designed to advance your
          career
        </p>
      </div>

      <div
        className="flex flex-wrap justify-center gap-2 mb-8"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`px-4 py-2 rounded border text-sm font-medium mb-2 ${
              selectedCategory === category
                ? "bg-blue-600 text-white"
                : "border-gray-300 text-gray-700 hover:bg-gray-100"
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      {selectedCategory !== "All" && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
          <div className="flex items-center mb-2">
            <Code className="h-6 w-6 text-blue-600 mr-2" />
            <h2 className="text-xl font-semibold text-gray-900">
              {selectedCategory} Courses
            </h2>
          </div>
          <p className="text-gray-700">
            {courseDescriptions[selectedCategory]}
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {filteredCourses.map((course, index) => {
          const aosAnimations = ["fade-left", "fade-up-left", "zoom-in-left"];
          const aosType = aosAnimations[index % aosAnimations.length];

          return (
            <div
              key={course.id}
              data-aos={aosType}
              data-aos-duration="1000"
              className="bg-white border rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition duration-300 relative"
            >
              {course.title.toLowerCase().includes("full stack") && (
                <span className="absolute top-2 right-2 bg-green-500 text-white text-xs font-medium px-2 py-1 rounded flex items-center z-10">
                  <Zap className="h-3 w-3 mr-1" /> Popular
                </span>
              )}

              <div className="overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-48 object-cover rounded-t hover:scale-105 transition-transform duration-300 shadow"
                />
              </div>
              <div className="p-4">
                <div className="text-xs text-blue-600 font-medium mb-1">
                  {course.category}
                </div>
                <h3 className="text-lg font-bold mb-1 text-black">
                  {course.title}
                </h3>
                <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                  {course.description}
                </p>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-2">
                  <div className="flex items-center">
                    <Clock className="h-4 w-4 mr-1" />
                    {course.duration}
                  </div>
                  <div className="flex items-center">
                    <Users className="h-4 w-4 mr-1" />
                    {course.students}
                  </div>
                </div>
                <div className="flex items-center">
                  <Star className="h-4 w-4 text-yellow-400 mr-1" />
                  <span className="text-sm font-medium text-black">
                    {course.rating}
                  </span>
                </div>
              </div>
              <div className="p-4 pt-0">
                <Link
                  to={course.slug} // Use slug as-is
                  className="block text-center w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition"
                >
                  Learn More
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
